<template>
  <div
    class="tw-flex tw-flex-col md:tw-flex-row md:tw-mx-10 tw-mt-3 tw-justify-between tw-mx-4 tw-px-8 tw-py-5 tw-border tw-border-black tw-rounded-4xl">
    <div class="" style="min-width: 160px;">
      <div class="tw-text-base">แพ็คเกจรอบบิลถัดไป</div>
      <div class="tw-text-black tw-font-bold tw-text-2xl tw-p-3 tw-pl-0">{{ paymentNextDetail.nameEN || '-' }}</div>
    </div>
    <div class="">
      <div class="tw-text-base">ค่าใช้จ่าย</div>
      <div class="tw-text-black tw-font-bold tw-text-3xl tw-relative tw-p-3 tw-pl-2">
        <span class="tw-text-sm tw-absolute tw-top-2 tw-left-0">฿</span>
        <span v-if="onCheckPackageType(paymentNextDetail)">
                    <span>{{ (paymentNextDetail.pricePerMonth / 100).toLocaleString() }}</span>
                    <span class="tw-text-sm tw-text-gray"> ต่อเดือน</span>
                  </span>
        <span v-else>
                    <span>{{ (paymentNextDetail.pricePerYear / 100).toLocaleString() }}</span>
                    <span class="tw-text-sm tw-text-gray"> ต่อปี</span>
                  </span>
      </div>
    </div>
    <div class="">
      <div class="tw-text-base">จำนวนเอกสารทั้งหมด</div>
      <div class="tw-flex tw-flex-row tw-justify-between tw-w-64 md:tw-w-80 tw-p-3 tw-pl-0">
        <div class="tw-font-bold tw-text-2xl tw-text-black">0%</div>
        <div class="tw-font-bold tw-text-base tw-text-gray">0 / {{paymentNextDetail.docsPerMonth}} ฉบับ</div>
      </div>
      <div class="tw-mt-1 tw-mb-2">
        <v-progress-linear
          height="8" background-color="#f2f2f2"
          color="#6ec39b" value="0">
        </v-progress-linear>
      </div>
    </div>
    <div class="">
      <div class="tw-text-base">สถานะแพ็คเกจ</div>
      <div class="tw-font-bold tw-text-2xl tw-text-gray tw-p-3 tw-pl-0">Inactive</div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'CompanyNextPlan',
  computed: mapState({
    nextPlan: state => state.companies.companyNextPlan,
    paymentNextDetail: state => state.paymentPlans.paymentNextDetail,
  }),
  created() {
    this.getDetailPackage()
  },
  methods: {
    onCheckPackageType: function (object) {
      return "pricePerMonth" in object
    },
    getDetailPackage: function () {
      this.$store.dispatch('paymentPlans/getDetail', {paymentPlanID: this.nextPlan['paymentPlanID'], nextPlan: true})
    }
  },
  watch:{
    nextPlan:{
      handler: function (nextPlan) {
        if(nextPlan){
          this.getDetailPackage()
        }
      },
    }
  }
}
</script>
